// src/components/dashboard/PlanCards/PlanCards.jsx - PRODUCTION MODE
import React, { useState, useEffect } from 'react';
import { planService } from '../../../services/planService';
import { useCurrency } from '../../../context/CurrencyContext';
import PlanCard from '../PlanCard/PlanCard';
import './PlanCards.css';

const PlanCards = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { currency } = useCurrency();

  // Auto-refresh daily to check/apply growth
  useEffect(() => {
    const refreshInterval = setInterval(() => {
      fetchSavingsPlans();
    }, 86400000); // 24 hours
    
    return () => clearInterval(refreshInterval);
  }, []);

  useEffect(() => {
    fetchSavingsPlans();
  }, [currency]);

  // Listen for currency change events
  useEffect(() => {
    const handleCurrencyChange = () => {
      fetchSavingsPlans();
    };

    window.addEventListener('currencyChange', handleCurrencyChange);
    return () => window.removeEventListener('currencyChange', handleCurrencyChange);
  }, []);

  // Listen for plan status changes (withdrawals, etc.)
  useEffect(() => {
    const handlePlanStatusChange = () => {
      console.log('📢 Plan status changed event received - refreshing plans');
      fetchSavingsPlans();
    };

    window.addEventListener('planStatusChanged', handlePlanStatusChange);
    return () => window.removeEventListener('planStatusChanged', handlePlanStatusChange);
  }, []);

  const fetchSavingsPlans = async () => {
    try {
      setLoading(true);
      const savingsPlans = await planService.getUserPlans();
      console.log('📦 Plans fetched:', savingsPlans);
      
      // Filter out COMPLETED plans on frontend as extra safety
      const activePlans = savingsPlans.filter(plan => plan.status !== 'COMPLETED');
      console.log('📦 Active/Matured plans after filter:', activePlans);
      
      setPlans(activePlans);
    } catch (err) {
      setError('Failed to load savings plans');
      console.error('Error fetching savings plans:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleNavigateToPlan = () => {
    window.location.href = '/plan';
  };

  if (loading) {
    return (
      <div className="plan-cards-container">
        <div className="plan-cards-header">
          <h2>Your Income Plan</h2>
          <p>Track your income plan projected performance</p>
        </div>
        <div className="plan-cards-loading">Loading your Income plans...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="plan-cards-container">
        <div className="plan-cards-header">
          <h2>Your Income Plan</h2>
          <p>Track your income plan projected performance</p>
        </div>
        <div className="plan-cards-error">
          {error}
          <button className="retry-button" onClick={fetchSavingsPlans}>
            Try Again
          </button>
        </div>
      </div>
    );
  }

  if (!plans || plans.length === 0) {
    return (
      <div className="plan-cards-container">
        <div className="plan-cards-header">
          <h2>Your Income Plan</h2>
          <p>Track your income plan projected performance</p>
        </div>
        <div className="no-plans-container" onClick={handleNavigateToPlan}>
          <div className="no-plans-icon">💼</div>
          <div className="no-plans-content">
            <h3>No Income Plan Yet</h3>
            <p>Start your plan by creating your first structured income plan</p>
            <button className="create-plan-btn">
              Create your Savings Plan →
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="plan-cards-container">
      <div className="plan-cards-header">
        <h2>Your Income Plan</h2>
        <p>Track your income plan projected performance</p>
      </div>
      
      <div className="plan-cards-grid">
        {plans.map(plan => (
          <PlanCard key={plan.id} plan={plan} />
        ))}
      </div>
    </div>
  );
};

export default PlanCards;